import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { BaseField, filterDOMProps, nothing } from 'uniforms';

var HiddenField =
/*#__PURE__*/
function (_BaseField) {
  _inherits(HiddenField, _BaseField);

  function HiddenField() {
    var _this;

    _classCallCheck(this, HiddenField);

    // @ts-ignore
    _this = _possibleConstructorReturn(this, _getPrototypeOf(HiddenField).apply(this, arguments));
    _this.options = {
      ensureValue: true,
      overrideValue: true
    };
    return _this;
  }

  _createClass(HiddenField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var valueDesired = _ref.value;

      if (valueDesired === undefined) {
        return;
      }

      var props = this.getFieldProps();

      if (props.value !== valueDesired) {
        props.onChange(valueDesired);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.getFieldProps();
      return props.noDOM ? nothing : React.createElement("input", Object.assign({
        disabled: props.disabled,
        id: props.id,
        name: props.name,
        ref: props.inputRef,
        type: "hidden",
        value: props.value
      }, filterDOMProps(props)));
    }
  }]);

  return HiddenField;
}(BaseField);

export { HiddenField as default };
HiddenField.displayName = 'HiddenField';